import React, { Component } from 'react';
import Switch from "react-switch";

import { consultApPeriodos, updPeriodoAP } from "../../../funciones/AdmisionFunction";

class ApPeriodos extends Component {
    state = {
        check: false,
        status: 0,
    }

    constructor (props) {
        super (props)

        setTimeout(() => {
            consultApPeriodos (this.props.datos.id, (resp) => {
                this.setState({
                    check: resp,
                    status: 1
                })
            })
        }, this.props.num);
    } 

    addPeriodo = () => {
        this.setState({
            check : !this.state.check
        }, () => {
            updPeriodoAP (this.props.datos.id, (resp) => {
                
            })
        })
    }

    checkP = () => {
        switch (this.state.status) {
            case 0:
                return (<i className ="fa fa-spinner fa-spin"></i>)
            case 1:
                return (
                    <Switch
                        height={12}
                        width={24}
                        onChange={this.addPeriodo}
                        checked={this.state.check}
                    />
                )
            default:
                return null;
        } 
    }

    render() {
        const { datos } = this.props;
        const styles = {
            padding: 5, fontSize: 12
        }

        let mes = (num) => {
            let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
            
            return meses[num - 1]
        }

        return (
            <tr style={{cursor:"pointer"}} onClick = {() => {this.props.funcion(datos.id, mes(datos.corte_name), datos.corte_year)}}>
                <td align="center" style={styles}>{mes(datos.corte_name)}</td>
                <td align="center" style={styles}>{datos.corte_year}</td>
                <td align="center" style={styles}>
                    {this.checkP()}
                </td>
            </tr>
        );
    }
}
 
export default ApPeriodos;


// WEBPACK FOOTER //
// ./src/views/Registros/PreferenciasContent/ApPeriodos.jsx